import React, { useEffect, useState } from "react";
import {
  amountFormatter,
  amountInWords,
  getLatestBid,
  getAllBidsForBanker,
  getAllWrongBidsForBanker,
} from "services";
import { DateTime } from "luxon";
import BidsHistory from "./BidsHistory";
import { ModalBase } from "@reusejs/react";

export interface EventDetailsPorps {
  event?: any;
}

export default function EventDetails(props: EventDetailsPorps) {
  const [lastBid, setLastBid] = useState<any>(null);
  const [correctBids, setCorrectBids] = useState<any[]>([]);
  const [wrongBids, setWrongBids] = useState<any[]>([]);

  useEffect(() => {
    init(props.event.uuid);
  }, [props.event]);

  const init = async (uuid: string) => {
    const lastBids: any = await getLatestBid(uuid);
    if (lastBids) {
      setLastBid(lastBids);
    }
    const allBids: any = await getAllBidsForBanker(uuid);
    if (allBids) {
      setCorrectBids(allBids);
    }
    const allWrongBids: any = await getAllWrongBidsForBanker(uuid);
    if (allWrongBids) {
      setWrongBids(allWrongBids);
    }
  };

  const openModal = async (correctBids: any, wrongBids: any) => {
    const BidsHistoryModalWrapper = (props: any) => {
      return (
        <BidsHistory
          correctBids={correctBids}
          userWrongBids={wrongBids}
          type="end"
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: BidsHistoryModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "w-full sm:max-w-2xl",
        },
      },
      1000,
      "__next"
    );
  };

  const handleBidsHistory = () => {
    openModal(correctBids, wrongBids);
  };

  return (
    <div className="">
      <div className="col-span-2 border-b text-lg text-blue-600 border-blue-400 font-semibold pb-2 text-center">
        Auction Result
      </div>
      {correctBids.length === 0 ? (
        <div className="text-gray-600 text-base font-medium text-center p-4">
          The auction event has been ended successfuly but unfortunately no one
          participated in the auction.
        </div>
      ) : (
        <>
          <div className="text-gray-600 text-base font-medium text-center py-4 px-8">
            The auction event has been ended successfuly and{" "}
            <a
              href={`mailTo:${
                lastBid && lastBid?.meta?.email
              }?subject=Congratulation!`}
              className="font-semibold text-lg hover:text-blue-600"
            >
              {lastBid && lastBid?.meta?.email}
            </a>{" "}
            has won the auction with the highest bid of{" "}
            <span className="font-semibold text-lg">
              ₹ {lastBid && amountFormatter(lastBid.final_amount)}
            </span>
          </div>
          <div className="px-4">
            <div className="overflow-hidden bg-white shadow sm:rounded-lg">
              <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
                <dl className="sm:divide-y sm:divide-gray-200">
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Highest Bid
                    </dt>
                    <dd className="mt-1 text-sm font-semibold text-green-600 sm:col-span-2 sm:mt-0">
                      ₹ {lastBid && amountFormatter(lastBid.final_amount)}
                      {/* {amountInWords(lastBid.final_amount)} */}
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Highest Bid By
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {lastBid && lastBid?.meta?.email}
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Highest Bid At
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {/* {lastBid && lastBid?.bid_timestamp} */}
                      {lastBid &&
                        lastBid?.bid_timestamp &&
                        `${DateTime.fromMillis(
                          typeof lastBid?.bid_timestamp === "string"
                            ? parseInt(lastBid?.bid_timestamp)
                            : lastBid?.bid_timestamp
                        )
                          .setZone("Asia/Kolkata")
                          .toFormat("DD hh:mm:ss a")} (IST)`}
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Auction Ended At
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {lastBid &&
                        lastBid?.final_end_time &&
                        `${DateTime.fromMillis(
                          typeof lastBid?.final_end_time === "string"
                            ? parseInt(lastBid?.final_end_time)
                            : lastBid?.final_end_time
                        )
                          .setZone("Asia/Kolkata")
                          .toFormat("DD hh:mm:ss a")} (IST)`}
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Currency
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      INR
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Number of Extension
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {lastBid && lastBid.number_of_extension
                        ? lastBid.number_of_extension
                        : "0"}
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Number of Successful Bids
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {correctBids && correctBids.length}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
            <div className="flex justify-end mt-2">
              <span
                className="text-sm hover:text-blue-600 cursor-pointer"
                onClick={() => handleBidsHistory()}
              >
                Bids History
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
